<template>
    <tr
        class="c-o-table__tr c-o-table__tr--flip-at-small c-o-table--with-actions"
    >
        <td class="c-o-table__td">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Förfrågan:</span
            >
            <router-link
                :to="{
                    name: 'Förfrågan (Mina sidor)',
                    params: { id: request.Id }
                }"
                >{{ request.Title }}</router-link
            >
        </td>

        <td class="c-o-table__td" nowrap>
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Datum:</span
            >
            {{ request.CreatedDate | formatDateWithoutTime }}
        </td>

        <td class="c-o-table__td u-padding-top-2">
            <span v-if="!isDesktop" class="c-o-table__inline-label">Typ:</span>
            <div class="c-o-table__pills">
                <status-pill v-if="request.SecureJob" :status="'active'"
                    >TryggtJobb</status-pill
                >
                <status-pill v-if="request.IsDirectRequest" :status="'active'"
                    >Direktförfrågan</status-pill
                >
                <status-pill v-if="contract.status" :status="contract.status">{{
                    contract.label
                }}</status-pill>
                <status-pill v-if="request.Channel.Name" :status="'active'">{{
                    request.Channel.Name
                }}</status-pill>
            </div>
        </td>

        <td class="c-o-table__td u-padding-bottom-2">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Omdöme:</span
            >
            <router-link
                v-if="request.Rating"
                :to="`/hantverkare/${request.Rating.CompanyID}/#ratings`"
            >
                <rating-atom
                    :ratingValue="request.Rating.RatingValue"
                    :showNr="false"
                ></rating-atom>
            </router-link>
            <rating-atom v-else :showNr="false"></rating-atom>
        </td>

        <td class="c-o-table__td u-padding-top-2">
            <span v-if="!isDesktop" class="c-o-table__inline-label"
                >Besvarade:</span
            >
            {{ request.AnswerCount }} / {{ request.TotalAnswers }}
        </td>

        <td class="c-o-table__td c-o-table__actions">
            <button-group>
                <atom-button
                    class="c-a-button--circle c-m-card__button"
                    :class="
                        request.Active
                            ? 'c-a-button--theme-success'
                            : 'c-a-button--theme-alert'
                    "
                    @buttonClicked="toggleStatus()"
                    icon="check"
                    aria-label="Toggla status"
                ></atom-button>
                <button-link
                    class="c-a-button--theme-primary c-a-button--circle c-m-card__button"
                    :link="{
                        name: 'Förfrågan (Mina sidor)',
                        params: { id: request.Id }
                    }"
                    icon="arrow_forward"
                    aria-label="Gå till förfrågan"
                ></button-link>
            </button-group>
        </td>
    </tr>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_CONTRACT_REQUEST_IDS } from "../../../store/store-models/contract-model";

import AtomButton from "../atoms/AtomButton.vue";
import ButtonLink from "../atoms/AtomButtonLink.vue";
import Filters from "../../../filters/index.js";
import StatusPill from "../atoms/AtomStatus.vue";
import RatingAtom from "../atoms/AtomRating.vue";
import ButtonGroup from "../molecules/MoleculeButtonGroup.vue";

export default {
    props: {
        request: Object
    },
    components: {
        AtomButton,
        ButtonLink,
        StatusPill,
        RatingAtom,
        ButtonGroup
    },
    filters: Filters,
    computed: {
        ...mapGetters({
            contractRequestIds: GET_CONTRACT_REQUEST_IDS
        }),
        status: function() {
            return this.request.Active
                ? { status: "active", label: "Aktiv" }
                : { status: "inactive", label: "Inaktiv" };
        },
        contract: function() {
            let index = this.contractRequestIds
                .map(x => x.requestId)
                .indexOf(this.request.Id);
            if (index > -1) {
                let label = "";
                switch (this.contractRequestIds[index].status) {
                    case 1:
                        label = "Avtal begärt";
                        break;
                    case 2:
                        label = "Avtal finns";
                        break;
                }

                return {
                    status: "contract",
                    label: label
                };
            }
            return {
                status: "",
                label: ""
            };
        },
        isDesktop: function() {
            return this.$mq === "medium" ||
                this.$mq === "large" ||
                this.$mq === "xLarge"
                ? true
                : false;
        }
    },
    methods: {
        toggleStatus: function() {
            this.$emit("toggleStatus", this.request);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeRequestsListCustomerTableRow.vue